<template>
  <section>
    <nav-component :titulo="'Deliveries'" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Deliveries</b-breadcrumb-item>
    </b-breadcrumb>

    <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />
    <div class="field mt-3">
      <busqueda-chofer @seleccionado="onSeleccionado" @deseleccionado="onDeseleccionado" />
    </div>

    <mensaje-inicial class="mt-2" :titulo="'No se han encontrado deliveries :('"
      :subtitulo="'Aquí aparecerán los deliveries registrados'" v-if="!cargando && total === 0" />

    <template v-if="total > 0 || cargando">
      <cartas-totales :totales="totalesGenerales" />

      <div class="table-toolbar">
        <div class="table-toolbar-left">
          <b-select v-model="porPagina" @input="cambiarPorPagina" size="is-small">
            <option :value="10">10 / pág</option>
            <option :value="20">20 / pág</option>
            <option :value="50">50 / pág</option>
          </b-select>
          <b-tag type="is-info">{{ total }} deliveries</b-tag>
        </div>
        <div class="table-toolbar-right">
          <b-button type="is-primary" size="is-small" icon-left="printer" tag="a" :href="printHref" target="_blank" rel="noopener noreferrer">
            Imprimir
          </b-button>
        </div>
      </div>

      <b-table
        class="box"
        :data="deliveries"
        :paginated="true"
        :per-page="porPagina"
        :current-page="pagina"
        :total="total"
        :backend-pagination="true"
        :pagination-rounded="true"
        pagination-position="bottom"
        @page-change="onCambioPagina"
      >
        <b-table-column field="fecha"         label="Fecha"    sortable v-slot="props">{{ formatFecha(props.row.fecha) }}</b-table-column>
        <b-table-column field="nombreChofer"  label="Chofer"   sortable v-slot="props">{{ props.row.nombreChofer }}</b-table-column>
        <b-table-column field="nombreCliente" label="Cliente"  sortable v-slot="props">{{ props.row.nombreCliente }}</b-table-column>
        <b-table-column field="costo"         label="Costo"    sortable v-slot="props">${{ formatoMonto(props.row.costo) }}</b-table-column>
        <b-table-column field="gratis"        label="Gratis"   sortable v-slot="props">
          <b-tag :type="props.row.gratis ? 'is-success' : 'is-danger'">{{ props.row.gratis ? 'Sí' : 'No' }}</b-tag>
        </b-table-column>
        <b-table-column field="destino"       label="Destino"  sortable v-slot="props">{{ props.row.destino }}</b-table-column>
      </b-table>
    </template>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import BusquedaChofer from '../Choferes/BusquedaChofer'
import BusquedaEnFecha from '../Extras/BusquedaEnFecha'
import MensajeInicial from '../Extras/MensajeInicial'
import CartasTotales from '../Extras/CartasTotales'
import NavComponent from '../Extras/NavComponent'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

export default {
  name: "DeliveriesComponent",
  components: { BusquedaEnFecha, BusquedaChofer, NavComponent, MensajeInicial, CartasTotales },

  data: () => ({
    filtros: { fechaInicio: "", fechaFin: "" },
    pagina: 1,
    porPagina: 20,
    total: 0,
    totalesGenerales: [],
    cargando: false,
    deliveries: [],
    choferId: null,
  }),

  mounted() {
    this.obtenerDeliveries()
  },

  computed: {
    printHref() {
      let href = '#/pdf/deliveries'
      const entries = Object.entries(this.filtros).filter(([, v]) => Boolean(v))
      if (this.choferId) entries.push(['choferId', this.choferId])
      if (entries.length === 0) return href
      return `${href}?${new URLSearchParams(Object.fromEntries(entries)).toString()}`
    },
  },

  methods: {
    formatoMonto(v) { return Utiles.formatoMonto(v) },
    formatFecha(f) {
      return new Date(f).toLocaleDateString('es-ES', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }).replace(/\//g, '-')
    },

    onCambioPagina(p) { this.pagina = p; this.obtenerDeliveries() },
    cambiarPorPagina() { this.pagina = 1; this.obtenerDeliveries() },

    obtenerDeliveries() {
      this.cargando = true
      HttpService.obtenerConConsultas("deliveries.php", {
        accion: "obtener",
        filtros: { ...this.filtros, choferId: this.choferId },
        pagina: this.pagina,
        porPagina: this.porPagina,
      }).then(resp => {
        if (Array.isArray(resp)) {
          this.deliveries = resp; this.total = resp.length
          this.totalesGenerales = []
        } else {
          this.deliveries = resp.deliveries || resp.data || []
          this.total = resp.total || this.deliveries.length
          this.totalesGenerales = resp.totales || []
        }
        this.cargando = false
      })
    },

    onBusquedaEnFecha(fechas) {
      this.filtros.fechaInicio = fechas[0]?.toISOString().split('T')[0] || ""
      this.filtros.fechaFin    = fechas[1]?.toISOString().split('T')[0] || ""
      this.pagina = 1
      this.obtenerDeliveries()
    },

    onDeseleccionado() { this.choferId = null; this.pagina = 1; this.obtenerDeliveries() },

    onSeleccionado(chofer) {
      this.choferId = chofer.id
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => { this.pagina = 1; this.obtenerDeliveries() }, 500)
    },
  }
}
</script>
